import { TheHousingHubLoading } from "app/components";
import { Suspense } from "react";

export default function TheHousingHubSuspense({ children }) {
  return <Suspense fallback={<TheHousingHubLoading />}>{children}</Suspense>;
}
